// product
import ProductCreateContainerView from 'containers/Product/Create';
import { ProductAddContainer } from 'containers/Product/Add';
import { ProductAddReturnedContainer } from 'containers/Product/Add';
import StylistAssignContainer from 'containers/Product/Stylist';
import { Returns } from 'modules/boxes/boxes-returns/returns';
import { ProductDamage } from 'modules/products/product-damage';

// distribution
import { LateBoxes } from 'modules/distribution/late-boxes';
import { MissingItems } from 'modules/distribution/missing-items';
import { DistributionDashboard } from 'modules/distribution/distribution-dashboard';
import { ShipmentLists } from 'modules/distribution/shipment-lists';

//search
import ProductSearchContainer from 'containers/Search/Product';
import UserEditContainer from 'modules/customers/customer-edit';
import { ProductEditContainer } from 'containers/Search/EditProduct';

// buyer modules
// import AddBrandSupplierComponent from 'containers/Brands';
import SwipeGameComponent from 'containers/SwipeGame';
import Overstock from 'modules/incoming-goods/overstock/dashboard';
import ClosetPreview from 'modules/incoming-goods/closet-preview';

// employees
import { Employees } from 'modules/employees';
import StylistInterface from 'modules/stylist-interface';
import { CustomerSearch } from 'modules/customers/customer-search';

// overstock
import { ModelEdit } from 'modules/incoming-goods/overstock';
import { ModelCreate } from 'modules/incoming-goods/overstock';
import { ProductsUpload } from 'modules/incoming-goods/overstock';
import { ProductsByModel } from 'modules/incoming-goods/overstock';
import Garments from 'containers/Garments/Garments';
import UpdateGarments from "containers/Garments/UpdateGarments/UpdateGarments";
import MintCondition from 'containers/MintCondition/MintCondition';
import UpdateMintCondition from 'containers/MintCondition/UpdateMintCondition/UpdateMintCondition';
import Sizes from 'containers/Sizes/Sizes';
import UpdateSizes from 'containers/Sizes/UpdateSizes/UpdateSizes';
import WashWith from 'containers/WashWith/WashWith';
import UpdateWashWith from 'containers/WashWith/UpdateWashWith/UpdateWashWith';
import Category from 'containers/Category/Category';
import UpdateCategory from 'containers/Category/UpdateCategory/UpdateCategory';
import Brand from 'containers/Brand/Brand';
import UpdateBrand from 'containers/Brand/UpdateBrand/UpdateBrand';
import SellingPlateform from 'containers/SellingPlateForm/SellingPlateform';
import UpdateSellingPlateform from 'containers/SellingPlateForm/UpdateSellingPlateform/UpdateSellingPlateform';
import ClothingMaterial from 'containers/ClothingMaterials/ClothingMaterial';
import UpdateClothingMaterial from 'containers/ClothingMaterials/UpdateClothingMaterial/UpdateClothingMaterial';
import Supplier from 'containers/Supplier/Supplier';
import UpdateSupplier from 'containers/Supplier/UpdateSupplier/UpdateSupplier';


const Roles = {
    STYLIST: 'stylist',
    PACKER: 'packer',
    BUYER: 'buyer',
    QUALITY_CHECK: 'quality_check',
    SENDER: 'sender',
    CUSTOMER_SUPPORT: 'customer_support',
    RETURN_MANAGER: 'return_manager',
    ADMIN: 'admin'
}

let modulesGroup = [
    {
        name: 'Closet Hackers',
        icon: 'fas fa-users',
        subMenu: [
            {
                name: 'Search',
                singleItemName: 'Search Closet Hackers',
                icon: 'fas fa-search',
                url: '/closet-hackers',
                component: CustomerSearch,
                roles: [Roles.STYLIST, Roles.PACKER, Roles.QUALITY_CHECK, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.RETURN_MANAGER, Roles.ADMIN],
                defaultTo: [Roles.STYLIST, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN]
            }
        ],
        subPages: [
            {
                name: 'Edit User', url: '/closet-hackers/:id',
                component: UserEditContainer,
                roles: [Roles.STYLIST, Roles.PACKER, Roles.QUALITY_CHECK, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.RETURN_MANAGER, Roles.ADMIN]
            },
            {
                name: 'Stylist Profile', url: '/closet-hackers/:id/style',
                component: StylistInterface,
                roles: [Roles.STYLIST, Roles.PACKER, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.RETURN_MANAGER, Roles.ADMIN]
            },
        ]
    },
    {
        name: 'Products',
        icon: 'fas fa-tshirt',
        subMenu: [
            {
                name: 'Add',
                singleItemName: 'Add Product',
                icon: 'fas fa-plus-square',
                url: '/products/add',
                component: ProductCreateContainerView,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
            {
                name: 'Search',
                singleItemName: 'Search Products',
                icon: 'fas fa-search',
                url: '/products',
                component: ProductSearchContainer,
                roles: [Roles.BUYER, Roles.STYLIST, Roles.PACKER, Roles.QUALITY_CHECK, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN, Roles.RETURN_MANAGER],
                defaultTo: [Roles.BUYER,Roles.ADMIN]
            },
            {
                name: 'Repairs',
                singleItemName: 'Repairs',
                icon: 'fas fa-splotch',
                url: '/damage-report',
                component: ProductDamage,
                roles: [Roles.BUYER, Roles.STYLIST, Roles.PACKER, Roles.QUALITY_CHECK, Roles.SENDER, Roles.ADMIN, Roles.RETURN_MANAGER],
                defaultTo: [Roles.QUALITY_CHECK]
            },
        ],
        subPages: [
            {
                name: 'Edit Product', url: '/products/:id',
                component: ProductEditContainer,
                roles: [Roles.BUYER, Roles.STYLIST, Roles.QUALITY_CHECK, Roles.PACKER, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN, Roles.RETURN_MANAGER]
            }
        ]
    },
    {
        name: 'Boxes',
        icon: 'fas fa-box',
        subMenu: [
            {
                name: 'Create',
                singleItemName: 'Create Box',
                icon: 'fas fa-people-carry',
                url: '/boxes/create',
                component: ProductAddContainer,
                roles: [Roles.STYLIST, Roles.PACKER, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.RETURN_MANAGER, Roles.ADMIN],
                defaultTo: [Roles.PACKER]
            },
            {
                name: 'Return',
                singleItemName: 'Return Box',
                icon: 'fas fa-box-open',
                url: '/boxes/return',
                component: Returns,
                roles: [Roles.STYLIST, Roles.PACKER, Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.RETURN_MANAGER, Roles.ADMIN],
                defaultTo: [Roles.RETURN_MANAGER]
            },
            {
                name: 'Create a returned box',
                singleItemName: 'Create Box',
                icon: 'fas fa-people-carry',
                url: '/boxes/create-retrospectively',
                component: ProductAddReturnedContainer,
                roles: [Roles.ADMIN]
            }
        ]
    },
    {
        name: 'Distribution',
        icon: 'fas fa-paper-plane',
        subMenu: [
            {
                name: 'Assign Stylist',
                icon: 'fas fa-user-plus',
                url: '/stylist',
                component: StylistAssignContainer,
                roles: [Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN]
            },
            {
                name: 'Missing items',
                icon: 'fas fa-question-circle',
                url: '/missing-items',
                component: MissingItems,
                roles: [Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN]
            },
            {
                name: 'Late boxes',
                icon: 'fas fa-clock',
                url: '/late-boxes',
                component: LateBoxes,
                roles: [Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN]
            },
            {
                name: 'Dashboard',
                icon: 'fas fa-truck',
                url: '/distribution-dashboard',
                component: DistributionDashboard,
                roles: [Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN]
            },
            {
                name: 'Shipment Lists',
                icon: 'fas fa-list',
                url: '/shipment-lists',
                component: ShipmentLists,
                roles: [Roles.SENDER, Roles.CUSTOMER_SUPPORT, Roles.ADMIN]
            }
        ]
    },
    {
        name: 'Incoming Goods',
        icon: 'fas fa-money-check-alt',
        subMenu: [
            // {
            //     name: 'Add Brand',
            //     icon: 'fas fa-folder-plus',
            //     url: '/brands/add',
            //     component: AddBrandSupplierComponent,
            //     roles: [Roles.BUYER, Roles.ADMIN],
            //     defaultTo: [Roles.BUYER]
            // },
            {
                name: 'Swipe Game',
                icon: 'fas fa-gamepad',
                url: '/swipe-game',
                component: SwipeGameComponent,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
            {
                name: 'Overstock',
                icon: 'fas fa-puzzle-piece',
                url: '/overstock',
                component: Overstock,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
            {
                name: 'Closet Preview',
                icon: 'fas fa-camera-retro',
                url: '/closet-preview',
                component: ClosetPreview,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
        ],
        subPages: [
            {
                name: 'Create Model', url: '/overstock/:id/create',
                component: ModelCreate,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
            {
                name: 'Edit Model', url: '/overstock/:id/edit',
                component: ModelEdit,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
            {
                name: 'UploadBatch', url: '/overstock/:id/upload',
                component: ProductsUpload,
                roles: [Roles.BUYER, Roles.ADMIN]
            },
            {
                name: 'Products Overstock', url: '/overstock/:id/products',
                component: ProductsByModel,
                roles: [Roles.BUYER, Roles.ADMIN]
            }
        ]
    },

];

let adminRoutes = {
    name: Roles.ADMIN,
    icon: 'fas fa-building',
    subMenu: [
        {
            name: 'Employees',
            icon: 'fas fa-building',
            url: '/employees',
            component: Employees,
            roles: [Roles.ADMIN]
        },
        {
            name: 'Sizes',
            icon: 'fas fa-folder-plus',
            url: '/sizes/add',
            component: Sizes,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Suppliers',
            icon: 'fas fa-folder-plus',
            url: '/supplier/add',
            component: Supplier,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Brands',
            icon: 'fas fa-folder-plus',
            url: '/brand/add',
            component: Brand,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Categories',
            icon: 'fas fa-folder-plus',
            url: '/category/add',
            component: Category,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Wash With',
            icon: 'fas fa-folder-plus',
            url: '/washwith/add',
            component: WashWith,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Condition',
            icon: 'fas fa-folder-plus',
            url: '/condition/add',
            component: MintCondition,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Garment Type',
            icon: 'fas fa-folder-plus',
            url: '/garmenttype/add',
            component: Garments,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Clothing Materials',
            icon: 'fas fa-folder-plus',
            url: '/clothingmaterial/add',
            component: ClothingMaterial,
            roles: [Roles.ADMIN],
        },
        {
            name: 'Selling Plateforms',
            icon: 'fas fa-folder-plus',
            url: '/sellingpleaseform/add',
            component: SellingPlateform,
            roles: [Roles.ADMIN],
        },

    ],
    subPages: [
        {
            name: '', url: '/update-garment/:id',
            component: UpdateGarments,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-supplier/:id',
            component: UpdateSupplier,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-sellingplateform/:id',
            component: UpdateSellingPlateform,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-clothingmaterial/:id',
            component: UpdateClothingMaterial,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-brand/:id',
            component: UpdateBrand,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-washwith/:id',
            component: UpdateWashWith,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-category/:id',
            component: UpdateCategory,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-mintcondition/:id',
            component: UpdateMintCondition,
            roles: [Roles.ADMIN]
        },
        {
            name: '', url: '/update-sizes/:id',
            component: UpdateSizes,
            roles: [Roles.ADMIN]
        },
    ]
}

if (window.localStorage.getItem('role') === 'admin') {
    modulesGroup.push(adminRoutes)
}

/**
 *
 * @param role
 */
export function getModulesByRole(role) {
    const menu = [];
    for (const group of modulesGroup) {
        if (!group.subMenu) { continue; }

        const subMenu = group.subMenu.filter(g => g.roles.includes(role));
        group.subMenu = subMenu;

        if (subMenu.length > 0) {
            menu.push(group);
        }
    };

    return menu;
}

/**
 *
 * @param role
 */
export function getRoutesByRole(role) {
    return modulesGroup.map(m => [...(m.subMenu ? m.subMenu : []), ...(m.subPages ? m.subPages : [])])
        .flat().filter(f => f.roles.includes(role));
}

/**
 *
 * @param role
 */
export function getDefaultPageByRole(role) {
    return modulesGroup
        .map(m => m.subMenu).flat()
        .filter(f => f.defaultTo)
        .filter(f => f.defaultTo.includes(role))
        .map(m => m.url).pop();
}
